import { useState } from 'react'
import LoginForm from './LoginForm'
import ResetPasswordForm from './ResetPasswordForm'

export type TLoginChildrenProps = {
  handleSwitchScreen: () => void
}

const Login = () => {
  const [currentScreen, setCurrentScreen] = useState<'login' | 'forgotPassword'>('login')

  const handleSwitchScreen = () =>
    setCurrentScreen((screen) => {
      if (screen === 'forgotPassword') {
        return 'login'
      } else {
        return 'forgotPassword'
      }
    })

  if (currentScreen === 'login') {
    return <LoginForm handleSwitchScreen={handleSwitchScreen} />
  }

  return <ResetPasswordForm handleSwitchScreen={handleSwitchScreen} />
}

export default Login
